import { EMPTY_TEXT, SEASON_LABELS, TONE_LABELS } from './constants';

import type { LabelDictionary } from './types';

export const renderValue = (value?: string) => value?.trim() || EMPTY_TEXT;

export const toLabel = (value: string | undefined, dictionary: LabelDictionary) => {
    if (!value) {
        return '';
    }

    return dictionary[value] ?? value;
};

export const buildPersonalColor = (season?: string, tone?: string) => {
    if (!season || !tone) {
        return '';
    }

    return `${toLabel(season, SEASON_LABELS)} ${toLabel(tone, TONE_LABELS)}`;
};
